import React, { Component } from "react";
import toast, { Toaster as ToasterSecond } from "react-hot-toast";
import next from "../build/images/icon_arrow_right.svg";
import { ReactComponent as CheckSucessIcon } from "../build/images/tick-circle.svg";
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { AuthLoginChangePass, AuthLogin } from "../actions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { connection_platform } from "../services/api";
var checkAlterSenha = true;

const mapDispatchToProps = (dispatch) => {
  return {
    onAddPost: (post, passwordNew) => {
      dispatch(AuthLoginChangePass(post, passwordNew));
    },
    onAddPost2: (post) => {
      dispatch(AuthLogin(post));
    },
  };
};

const closeToast = () => {
  toast.remove();
};

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    VerificarReasons: state.reasonsblock,
  };
};

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      result: {},
      class: "notification success",
      mensagem: "Nenhuma",
      redirect: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.email = "";
    this.contador = -1;
  }

  handleChange(event) {
    this.state = { value: "", result: {} };
    this.setState({ value: event.target.value, submitted: true });
  }

  clearErrorMessages() {
    const oDivAlerta1 = document.getElementById("msg_erro1");
    const oDivAlerta2 = document.getElementById("msg_erro2");
    const oDivAlerta3 = document.getElementById("msg_erro3");

    if (Boolean(oDivAlerta1) && Boolean(oDivAlerta2) && Boolean(oDivAlerta3)) {
      oDivAlerta1.innerHTML = "";
      oDivAlerta2.innerHTML = "";
      oDivAlerta3.innerHTML = "";
      this.setState({ mensagem: "Nenhuma", class: "notification success" });
    }
  }

  handleSubmit(event) {
    var oDivAlerta1 = document.getElementById("msg_erro1");
    var oDivAlerta2 = document.getElementById("msg_erro2");
    var oDivAlerta3 = document.getElementById("msg_erro3");
    var password = document.getElementById("current_password").value;
    var passwordNew = document.getElementById("new_password").value;
    var passwordNewRep = document.getElementById("new_password_repeat").value;

    event.preventDefault();

    var regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*.])(.{8,})$/;
    var checkPassword = regex.test(passwordNewRep);

    oDivAlerta1.style.display = "";
    oDivAlerta2.style.display = "";
    oDivAlerta3.style.display = "";

    this.clearErrorMessages();

    if (!password) {
      oDivAlerta1.style.display = "block";
      oDivAlerta1.innerHTML = "Digite sua senha atual";
      this.setState({
        class: "notification warning active",
        mensagem: "Por favor preencha todos os campos",
      });
    } else {
      oDivAlerta1.style.display = "";
    }
    if (!passwordNew) {
      oDivAlerta2.style.display = "block";
      oDivAlerta2.innerHTML = "Digite sua nova senha";
      this.setState({
        class: "notification warning active",
        mensagem: "Por favor preencha todos os campos",
      });
    } else {
      oDivAlerta2.style.display = "";
    }
    if (!passwordNewRep) {
      oDivAlerta3.style.display = "block";
      oDivAlerta3.innerHTML = "Preencha o campo sua nova senha";
    } else {
      oDivAlerta3.style.display = "";
    }

    if (password === passwordNewRep) {
      //oDivAlerta3.style.display = "block";
      //oDivAlerta3.innerHTML     = 'Nova senha diverge da confirmação de nova senha';
      this.setState({
        class: "notification warning active",
        mensagem: "Nova senha deve ser diferente da atual",
      });
    } else {
      oDivAlerta3.style.display = "";
    }

    if (!checkPassword) {
      //oDivAlerta3.style.display = "block";
      //oDivAlerta3.innerHTML     = 'Nova senha diverge da confirmação de nova senha';
      this.setState({
        class: "notification warning active",
        mensagem:
          "Nova senha deve conter pelo menos uma letra maiúscula, um caractere especial e ter no mínimo 8 caracteres.",
      });
    } else {
      oDivAlerta3.style.display = "";
    }

    if (passwordNew != passwordNewRep) {
      //oDivAlerta3.style.display = "block";
      //oDivAlerta3.innerHTML     = 'Nova senha diverge da confirmação de nova senha';
      this.setState({
        class: "notification warning active",
        mensagem: "Nova senha diverge da confirmação de nova senha",
      });

      if (oDivAlerta3) {
        oDivAlerta3.innerHTML = "Senha não confere";
      }
    } else {
      oDivAlerta3.style.display = "";
    }

    if (
      password &&
      passwordNew &&
      passwordNewRep &&
      passwordNew == passwordNewRep &&
      password !== passwordNew &&
      checkPassword
    ) {
      this.props.onAddPost(password, passwordNew);
    }
  }

  HandleLogin() {
    var passwordNewRep = document.getElementById("new_password_repeat").value;
    this.props.onAddPost2(passwordNewRep);
  }

  render() {
    const { redirect } = this.state;

    const { VerificarUser, VerificarReasons } = this.props;

    if (
      VerificarUser.displayname != undefined &&
      VerificarUser.error === undefined &&
      VerificarUser.error != true &&
      VerificarReasons != 0 &&
      !VerificarUser.force_password_change
    ) {
      return <Redirect to="/dashboard" />;
    }

    if (VerificarUser.sucess) {
      // this.state.class = "notification success active";
      // this.state.mensagem = "Senha alterada com sucesso!";
      // this.state.redirect = true;
      toast.custom(
        <div className="container__change-password_sucess">
          <div className="container__change-password__icon">
            <CheckSucessIcon />
          </div>
          <div className="container__change-password__separator">
            <div className="container__change-password__box">
              <strong>Senha alterada com sucesso!</strong>
              <div
                className="container__change-password__box-icon"
                onClick={() => closeToast()}
              >
                <IconClose />
              </div>
            </div>
          </div>
        </div>,
        {
          duration: 5000,
          position: "bottom-left",
        }
      );
    }

    if (VerificarUser.error) {
      this.state.class = "notification error active";
      this.state.mensagem = "Senha não confere, por favor digite corretamente.";
      const oDivAlerta1 = document.getElementById("msg_erro1");
      const oDivPasswordNew = document.getElementById("new_password");
      const oDivPasswordNewRep = document.getElementById("new_password_repeat");
      const oDivAlerta3 = document.getElementById("msg_erro3");
      if (
        Boolean(oDivAlerta1) &&
        Boolean(oDivPasswordNew) &&
        Boolean(oDivPasswordNewRep) &&
        Boolean(oDivAlerta3)
      ) {
        if (oDivPasswordNew.value !== oDivPasswordNewRep.value) {
          oDivAlerta3.innerHTML = "Senha não confere";
        } else {
          oDivAlerta1.innerHTML = "Senha incorreta";
        }
      }
    }

    if (VerificarUser.length === 0) return <Redirect to="/login" />;

    if (VerificarUser.force_password_change) {
      if (checkAlterSenha) {
        this.state.class = "notification warning active";
        this.state.mensagem = "Necessário alterar a senha atual.";
        checkAlterSenha = false;
      }
    }

    return (
      <div id="app">
        <div className="login">
          <div className={connection_platform.class_image_login}>
            {/* <h1>IngWeb</h1>
            <p>Otimizador de centros de atendimentos</p> */}
          </div>
          <div className="col-form">
            <div className="block no-round">
              <div className="block-content">
                <form
                  ref="FormChangePass"
                  onSubmit={this.handleSubmit}
                  className="row justify-content-md-center"
                >
                  <div className="form-group">
                    <h2>Para alterar sua senha</h2>
                    <p>preencha abaixo:</p>
                    <div className={this.state.class}>
                      <p>{this.state.mensagem}</p>
                    </div>
                    <div id="msg_erro4" className="invalid-feedback"></div>
                  </div>
                  {(() => {
                    if (this.state.redirect) {
                      return (
                        <div style={{ display: "none" }}>
                          <div className="form-group">
                            <input
                              type="password"
                              value={this.value}
                              onChange={this.handleChange}
                              name="current_password"
                              id="current_password"
                              placeholder="Senha atual"
                            />
                            <div
                              id="msg_erro1"
                              className="invalid-feedback"
                            ></div>
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              value={this.value}
                              onChange={this.handleChange}
                              name="new_password"
                              id="new_password"
                              placeholder="Nova senha"
                            />
                            <div
                              id="msg_erro2"
                              className="invalid-feedback"
                            ></div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div>
                          <div className="form-group">
                            <input
                              type="password"
                              value={this.value}
                              onChange={this.handleChange}
                              name="current_password"
                              id="current_password"
                              placeholder="Senha atual"
                            />
                            <div
                              id="msg_erro1"
                              className="invalid-feedback"
                            ></div>
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              value={this.value}
                              onChange={this.handleChange}
                              name="new_password"
                              id="new_password"
                              placeholder="Nova senha"
                            />
                            <div
                              id="msg_erro2"
                              className="invalid-feedback"
                            ></div>
                          </div>
                        </div>
                      );
                    }
                  })()}
                  <div className="form-group">
                    <input
                      type="password"
                      value={this.value}
                      onChange={this.handleChange}
                      name="new_password_repeat"
                      id="new_password_repeat"
                      placeholder="Repita a nova senha"
                    />
                    <div id="msg_erro3" className="invalid-feedback"></div>
                  </div>
                  {(() => {
                    if (this.state.redirect) {
                      return (
                        <div className="form-group">
                          <button
                            type="button"
                            onClick={(event) => this.HandleLogin(event)}
                            name="btnChangePass"
                            id="btnChangePass"
                            className="btn btn-primary btn-hero btn-small pull-right"
                          >
                            Login <img src={next} width="8" />
                          </button>
                        </div>
                      );
                    } else {
                      return (
                        <div className="form-group">
                          <button
                            type="submit"
                            onClick={this.handleClick}
                            name="btnChangePass"
                            id="btnChangePass"
                            className="btn btn-primary btn-hero btn-small pull-right"
                          >
                            Alterar minha senha <img src={next} width="8" />
                          </button>
                        </div>
                      );
                    }
                  })()}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
